/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The helper to map received data to formatted chart labels
 *
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

import { IChartLabels } from '../../../components/common/Chart/chartTypes';
import { formatNumberToPhone } from '../../../components/common/PhoneMask/formatNumberToPhone';
import {
    EExpensesAnalyzerField,
    IExpensesAnalyzerData,
} from '../components/ExpensesAnalyzerTable/types/expensesAnalyzerTableTypes';
import { EChartLabelType, TChartIdField } from '../types/pageExpensesAnalyzerTypes';

export const mapTableDataToChartLabels =
    (tableData: IExpensesAnalyzerData[], chartIdField: TChartIdField): IChartLabels => {
    return tableData.reduce((labels, item) => {
        const title = chartIdField === EExpensesAnalyzerField.MSISDN ?
            formatNumberToPhone(item[chartIdField]) : item[chartIdField];
        const subTitle = chartIdField === EExpensesAnalyzerField.MSISDN ?
            item[EExpensesAnalyzerField.NAME] : item[EExpensesAnalyzerField.ACCOUNT_REGION];
        const labelType = chartIdField === EExpensesAnalyzerField.MSISDN ?
            EChartLabelType.fio : EChartLabelType.region;
        return { ...labels,
            [item[chartIdField]]: {
                title: title.toString(),
                subTitle: subTitle?.toString() || '',
                labelType,
            },
        }
    }, {});
};
